let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7qTHr")).then(() => parcelRequire('7mL2C'));